import { QuillEditor } from './QuillEditor';

export function EditorContainer() {
  return (
    <div className="w-full">
      <QuillEditor />
    </div>
  );
}
